/* global VERSION BUILD IS_PRODUCTION */
import { trace } from './log';
import initEngine from './engine';

const globalName = 'marketing';

const exportGlobal = (lib, name = globalName) => {
  if (!window.TES) {
    window.TES = {};
  }
  if (!window.TES[name]) {
    window.TES[name] = lib;
  }
};

const docReady = (readyHandler) => {
  if (document.readyState === 'loading') {
    return document.addEventListener('DOMContentLoaded', readyHandler);
  }
  readyHandler();
};

docReady(() => {
  const _engine = initEngine(!IS_PRODUCTION);
  const { renderCampaign, mountSlot, unmountSlot, ackSlot } = _engine;
  exportGlobal({
    _engine,
    renderCampaign,
    ackSlot,
    mountSlot,
    unmountSlot
  });
  trace(`module-marketing-loader initialized. version: ${VERSION} build: ${BUILD}`);
  _engine.start();
});
